import { render } from "./CustomerTableControls.vue?vue&type=template&id=3043ae64&scoped=true&lang=pug"
import script from "./CustomerTableControls.vue?vue&type=script&lang=js"
export * from "./CustomerTableControls.vue?vue&type=script&lang=js"

import "./CustomerTableControls.vue?vue&type=style&index=0&id=3043ae64&lang=scss&scoped=true"
import "./CustomerTableControls.vue?vue&type=style&index=1&id=3043ae64&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3043ae64"]])

export default __exports__